// extracted by mini-css-extract-plugin
module.exports = {"layout":"Home_layout__1-JIT"};